/*
 * Spec collection — AJAX faceting (no full reload), price slider, mobile drawer.
 * Preserves Vehicle Finder fitment parameters while applying collection filters.
 * Fetches the updated collection HTML and swaps the grid + facets in place,
 * updating the URL via history so it stays shareable/back-button friendly.
 */
(function () {
  'use strict';

  var FITMENT_PARAM = 'filter.p.m.custom.fitment_handles';

  function initSection(root) {
    if (root.dataset.ccInit === 'true') return;
    root.dataset.ccInit = 'true';

    var form = root.querySelector('[data-cc-form]');
    if (!form) return;

    function setOpen(on) {
      root.classList.toggle('cc--filters-open', on);
      document.body.style.overflow = on ? 'hidden' : '';
    }

    function getCurrentFitmentValues() {
      var currentParams = new URLSearchParams(window.location.search);
      return currentParams.getAll(FITMENT_PARAM);
    }

    function appendFitmentValues(params) {
      /*
       * Os valores do Vehicle Finder não aparecem como checkboxes no formulário
       * porque o snippet spec-facets oculta a lista de compatibilidade.
       * Por isso, preservamo-los explicitamente a partir do URL atual.
       */
      params.delete(FITMENT_PARAM);

      getCurrentFitmentValues().forEach(function (value) {
        params.append(FITMENT_PARAM, value);
      });
    }

    function buildUrl() {
      var params = new URLSearchParams();

      form.querySelectorAll('.sf__check:checked').forEach(function (checkbox) {
        /*
         * Evita duplicar fitment_handles se, no futuro, este filtro passar
         * a existir como input visível ou oculto dentro do formulário.
         */
        if (checkbox.name !== FITMENT_PARAM) {
          params.append(checkbox.name, checkbox.value);
        }
      });

      var sort = form.querySelector('[data-cc-sort]');
      if (sort && sort.value) {
        params.set('sort_by', sort.value);
      }

      form.querySelectorAll('[data-price-min], [data-price-max]').forEach(function (priceInput) {
        if (priceInput.value) {
          params.set(priceInput.name, priceInput.value);
        }
      });

      appendFitmentValues(params);

      var queryString = params.toString();
      return window.location.pathname + (queryString ? '?' + queryString : '');
    }

    function buildClearFiltersUrl() {
      /*
       * "Limpar filtros" remove todos os filtros, incluindo o veículo
       * selecionado no Vehicle Finder, e regressa à coleção completa.
       */
      return window.location.pathname;
    }

    var controller = null;

    function render(url, push) {
      if (controller) controller.abort();

      controller = new AbortController();
      root.classList.add('cc--loading');

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(root.id) || doc.querySelector('[data-spec-collection]');

          if (fresh) {
            ['.cc__main', '.cc__sidebar', '.cc__count'].forEach(function (selector) {
              var newElement = fresh.querySelector(selector);
              var currentElement = root.querySelector(selector);

              if (newElement && currentElement) {
                currentElement.innerHTML = newElement.innerHTML;
              }
            });
          }

          if (push !== false) {
            window.history.pushState({ ccUrl: url }, '', url);
          }

          root.classList.remove('cc--loading');
          setOpen(false);

          // Volta a avaliar os indicadores "Compatível com o seu veículo".
          if (window.VehicleGarage) {
            document.dispatchEvent(
              new CustomEvent('vehicle:change', {
                detail: window.VehicleGarage.get()
              })
            );
          }

          // Desloca a grelha para a zona visível após a alteração dos filtros.
          var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
          if (window.pageYOffset > top) {
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;

          // Fallback: mantém o comportamento mesmo que o pedido AJAX falhe.
          window.location.href = url;
        });
    }

    function apply() {
      render(buildUrl(), true);
    }

    // Filtros e ordenação — delegados para continuarem ativos após o AJAX.
    root.addEventListener('change', function (event) {
      if (event.target.matches('.sf__check, [data-cc-sort]')) {
        apply();
      }

      if (event.target.matches('[data-price-slider]')) {
        apply();
      }

      if (event.target.matches('[data-price-min], [data-price-max]')) {
        apply();
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-price-slider]')) {
        var group = event.target.closest('.sf__price');
        var maxInput = group && group.querySelector('[data-price-max]');

        if (maxInput) {
          maxInput.value = event.target.value;
        }
      }
    });

    root.addEventListener('keydown', function (event) {
      if (
        event.target.matches('[data-price-min], [data-price-max]') &&
        event.key === 'Enter'
      ) {
        event.preventDefault();
        apply();
      }
    });

    // Paginação, limpar filtros e controlos do drawer.
    root.addEventListener('click', function (event) {
      var clearLink = event.target.closest('.cc__clear');

      if (clearLink) {
        event.preventDefault();
        render(buildClearFiltersUrl(), true);
        return;
      }

      var paginationLink = event.target.closest('.cc__pagination a');

      if (paginationLink && paginationLink.href) {
        event.preventDefault();

        /*
         * A paginação normalmente já herda os filtros ativos do Shopify.
         * Como proteção adicional, garantimos que os fitment_handles atuais
         * também seguem para a página seguinte.
         */
        var paginationUrl = new URL(paginationLink.href, window.location.origin);
        var paginationParams = paginationUrl.searchParams;

        paginationParams.delete(FITMENT_PARAM);
        getCurrentFitmentValues().forEach(function (value) {
          paginationParams.append(FITMENT_PARAM, value);
        });

        render(paginationUrl.pathname + '?' + paginationParams.toString(), true);
        return;
      }

      if (event.target.closest('[data-cc-open]')) {
        setOpen(true);
      }

      if (event.target.closest('[data-cc-close]')) {
        setOpen(false);
      }
    });

    // Navegação para trás/frente.
    window.addEventListener('popstate', function () {
      render(window.location.pathname + window.location.search, false);
    });
  }

  function boot(scope) {
    (scope || document)
      .querySelectorAll('[data-spec-collection]')
      .forEach(initSection);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();